import { createAxiosClient } from "@ntg/component-library/utilities";

export interface IDesignItemInfo {
    itemID: number;
    productID: number;
    name: string;
    entity: string;
    entityID: number;
    make: boolean;
}

export const getDesignItemsByDesignID = async (
    designID: number,
): Promise<IDesignItemInfo[]> => {
    const axiosAuth = createAxiosClient("D365FO");
    const response = await axiosAuth.get<IDesignItemInfo[]>(
        `/ReleasedProduct/GetDesignItemsByDesignID/${designID}`,
    );
    return response.data;
};
